//******************************************************************************
// Copyright 2018-2020, ShareSquared Inc., All Rights Reserved.
//
// Author:  Ted Iverson
// Created: 07/02/2020
//
// The contents of this file are proprietary and considered trade secret.
// Any disclosure outside of its intended use is expressly prohibited.
//******************************************************************************

import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';

export interface IErrorSectionProps {

    // the error message to display
    ErrorMessage: string;
}

export interface IErrorSectionState {
}

export default class ErrorSection extends React.Component<IErrorSectionProps, IErrorSectionState, {}> {

    public constructor(props: IErrorSectionProps, state: IErrorSectionState) {
        super(props, state);

        this.state = { };
    }

    public render(): React.ReactElement<IErrorSectionProps> {

        return this.props.ErrorMessage.length!==0 ? (
            <div className="S2ErrorMessage">
                <Label className="S2ErrorMessage">{this.props.ErrorMessage}</Label>
            </div>
        ) : (<span/>);
    }
}
